(function () {
  var root = document.documentElement;
  function setTheme(t) { root.setAttribute('data-theme', t); try { localStorage.setItem('gp-theme', t); } catch (e) {} paint(); }
  function paint() {
    var dark = root.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.innerHTML = dark
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/></svg>';
      b.setAttribute('aria-label', dark ? 'Switch to light theme' : 'Switch to dark theme');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (t) { setTheme(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark'); return; }
    var m = e.target.closest('#menuToggle');
    if (m) {
      var nav = document.getElementById('nav');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      m.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  paint();
})();

document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.site-header details[open]').forEach(function(d){d.open=false});var n=document.getElementById('nav');if(n)n.classList.remove('open');var b=document.getElementById('menuToggle');if(b)b.setAttribute('aria-expanded','false');}});document.addEventListener('click',function(e){if(!e.target.closest('.site-header'))document.querySelectorAll('.site-header details[open]').forEach(function(d){d.open=false});});
